import { ContactColumns, ContactImportFile, ContactImportSummary, InvalidImportedContact } from '../types';

export type ContactImportLogRow = {
  id: string;
  imported: number;
  updated: number;
  // Rows rejected outright, and rows imported with unusable fields dropped
  rejected: number;
  withErrors: number;
  dateUpdated: string;
  file: ContactImportFile | null;
  invalidContacts: InvalidImportedContact[];
  selectedColumns?: ContactColumns | null;
};

export const mapContactImportLogRow = (item: ContactImportSummary): ContactImportLogRow => {
  return {
    id: item.id,
    imported: item.numberOfImported,
    updated: item.numberOfUpdated,
    rejected: item.invalidContacts.filter(contact => !contact.contactId).length,
    withErrors: item.invalidContacts.filter(contact => !!contact.contactId).length,
    dateUpdated: item.dateUpdated,
    file: item.file ?? null,
    invalidContacts: item.invalidContacts,
    selectedColumns: item.selectedColumns ?? null,
  };
};
